/* eslint-disable */
import axios from 'axios';
import { devURL, httpsURL } from './backendURL';

export default () => {
    const baseURL = httpsURL;
    let access_token;

    let headers = {
        TwitterSSO: true
    };
    if (
        document.cookie.includes('oauth_token') &&
        document.cookie.includes('access_token')
    ) {
        const cookieObject = {};
        for (let token of document.cookie.split('; ')) {
            const [name, val] = token.split('=');
            cookieObject[name] = val;
        }
        headers.Authorization = 'Bearer ' + cookieObject['access_token'];
    }
    const axiosInstance = axios.create({
        baseURL,
        headers,
        withCredentials: true
    });

    axiosInstance.interceptors.response.use(
        (response) => {
            return new Promise((resolve, reject) => {
                resolve(response);
            });
        },
        (error) => {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    );

    return axiosInstance;
};
